"use client"

import {
  NavigateWithThread,
  EntityDetailSkeleton,
  useEvaluationSummary,
  buildRecruiterPersonMatchPath,
  getHrefWithThreadPreservation,
} from '@yeshuman/sdk'
import type { EvaluationAnalysisLocationState } from '@yeshuman/sdk'
import { useParams } from 'react-router-dom'
import { useLocation } from 'react-router-dom'

export function RecruiterEvaluationAnalysisRoute() {
  const { evaluationId } = useParams<{ evaluationId: string }>()
  const location = useLocation()
  const state = (location.state as EvaluationAnalysisLocationState | null) ?? {}
  const { evaluation, isLoading } = useEvaluationSummary(evaluationId)

  if (!evaluationId) {
    return <NavigateWithThread to="/recruiter/talent?tab=search" />
  }

  if (isLoading) {
    return <EntityDetailSkeleton variant="job" ariaLabel="Loading match analysis" />
  }

  const profileId = evaluation?.profile_id ?? state.profileId
  if (!profileId) {
    return <NavigateWithThread to="/recruiter/talent?tab=search" />
  }

  const briefId =
    state.backPath?.includes('/recruiter/briefs/')
      ? state.backPath.split('/recruiter/briefs/')[1]?.split('?')[0]
      : undefined

  const target = buildRecruiterPersonMatchPath(profileId, {
    briefId,
    evaluationId,
    tab: 'analysis',
  })

  return <NavigateWithThread to={getHrefWithThreadPreservation(target)} />
}
